export default {
  address: "Santiago, Chile",
  email: "f.olivaresrios@gmail.com",
  availability: "Inmediata",
  social: [
    {
      name: "Facebook",
      url: "https://www.facebook.com/folivaresrios/",
    },
    {
      name: "Instagram",
      url: "https://www.instagram.com/folivaresrios/",
    },
    {
      name: "Linkedin",
      url: "https://www.linkedin.com/in/folivaresrios/",
    },
    {
      name: "Twitter",
      url: "https://twitter.com/folivaresrios/",
    },
    {
      name: "GitHub",
      url: "https://github.com/folivaresrios/",
    },
  ],
};
